import React from 'react';
import { connect } from 'react-redux';
import { close } from '../../../actions/levelPopupActions';
// Shared imports
import { redirectTo } from '../../../../SharedUI/functions';

class ButtonsContainer extends React.Component {
    onRestart = () => {
        const { dispatch, levelPopup } = this.props;
        dispatch(close());

        if (levelPopup.onRestart) {
            levelPopup.onRestart();
        }
    };

    onGamesRedirect = () => {
        // Redirect to 'games' (REDIRECT BOOKMARK)
        redirectTo('games');
    };

    render = () => {
        return (
            <div className="buttons-container">
                <button type="button" onClick={this.onRestart}>
                    opnieuw
                </button>
                <button type="button" onClick={this.onGamesRedirect}>
                    ga naar games
                </button>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelPopup: state.levelPopup
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ButtonsContainer);
